/**
 * The current websocket connection's socket id, shared between the Pusher service
 * and the axios layer.
 *
 * It lives in its own module rather than on the Pusher service because
 * `src/config/api.js` cannot import `pusherService` — the Pusher service imports
 * the axios instance for its channel-auth calls, and the two would form a cycle.
 *
 * The API reads this back as the `X-Socket-ID` header and uses it to exclude the
 * tab that made a change from the broadcast of that change (ND-2335), so the
 * writer never processes an echo of its own write.
 */
let socketId = null

export function setSocketId(id) {
  socketId = id || null
}

export function getSocketId() {
  return socketId
}
